import { createSlice, isAnyOf, isPending } from '@reduxjs/toolkit';
import { submitApplicationData } from 'thunks';

const triggerThunks = [submitApplicationData];

export enum LoadingType {
  Update = 'update',
}

interface LoadingState {
  [LoadingType.Update]: boolean;
}

const initialState: LoadingState = {
  [LoadingType.Update]: false,
};

const loading = createSlice({
  name: 'loading',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    triggerThunks.forEach((thunk) => {
      builder.addMatcher(isPending(thunk), (state) => {
        state[LoadingType.Update] = true;
      });

      builder.addMatcher(isAnyOf(thunk.fulfilled, thunk.rejected), (state) => {
        state[LoadingType.Update] = false;
      });
    });
  },
});

export default loading.reducer;
